import React, { HTMLAttributes } from 'react'
import styled from 'styled-components'

const SFooter = styled.footer`
  display: flex;
  justify-content: space-between;
  color: ${(props) => props.theme.colors.footerTextColor}
`

const SSection = styled.div`
  margin-bottom: 10px;
`

const SMailLink = styled.a`
  color: ${(props) => props.theme.colors.footerTextColor};
  border-bottom: 1px solid;
  border-color: ${(props) => props.theme.colors.accent};
  text-decoration: none;
`

const Footer: React.FC<HTMLAttributes<HTMLDivElement>> = ({className}) => {
  return (
    <SFooter className={className}>
      <SSection>
        Комментарии по работе онлайн-калькуляторов просьба направлять
        <br/>
        на ящик технической поддержки: 
        <SMailLink href="mailto:calc@npfsb.ru»?subject=Комментарий по работе онлайн-калькуляторов">
          calc@npfsb.ru»
        </SMailLink>
      </SSection>
      <SSection>
        © Негосударственный пенсионный Фонд Сбербанка 2021
      </SSection>
    </SFooter>
  )
}

export default Footer